/*
 * Routes-discounts.ts
 * Description: Includes the declaration of the
 * discount routes for Vue Router
 */

// Importing components
import PageDiscountsUpdate from '@/pages/discounts/PageDiscountsUpdate.vue';
import PageDiscountsCreate from '@/pages/discounts/PageDiscountsCreate.vue';
import PageDiscounts from '@/pages/discounts/PageDiscounts.vue';

const routesDiscount = [
    // Defining the staff page route
    {
        path: '/restaurants/:id/discounts',
        name: 'discounts',
        component: PageDiscounts,
        props: { id: Number },
        meta: { requiresAuth: true, ManageStaff: true },
    },
    // Defining the staff create page route
    {
        path: '/restaurants/:id/discounts/create',
        name: 'discounts-create',
        component: PageDiscountsCreate,
        props: { id: Number },
        meta: { requiresAuth: true, ManageStaff: true },
    },
    // Defining the staff update page route
    {
        path: '/restaurants/:id/discounts/:discount_id/update',
        name: 'discounts-update',
        component: PageDiscountsUpdate,
        props: { id: Number, discount_id: Number },
        meta: { requiresAuth: true, ManageStaff: true },
    },
];
export default routesDiscount;
